import { Stack } from "@mui/material";
import { RootPaths } from "@src/appV2/App/paths";

import { GoogleMapErrorBoundary } from "../../GeoLocation/GoogleMapErrorBoundary";
import {
  SHIFT_DISCOVERY_IN_HOME_PATH,
  SHIFT_DISCOVERY_LIST_PATH,
  SHIFT_DISCOVERY_MAP_PATH,
} from "../../ShiftDiscovery/paths";
import { ShiftDiscoverySearchModeSwitcher } from "../../ShiftDiscovery/SearchModeSwitcher";
import { InHomeVisitsMap } from "./InHomeVisitsMap";

export function InHomeMapView() {
  return (
    <Stack sx={{ flex: 1, position: "relative", overflow: "hidden" }}>
      <GoogleMapErrorBoundary>
        <InHomeVisitsMap />
      </GoogleMapErrorBoundary>

      <ShiftDiscoverySearchModeSwitcher
        listHref={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_LIST_PATH}/${SHIFT_DISCOVERY_IN_HOME_PATH}`}
        mapHref={`${RootPaths.APP_V2_HOME}/${SHIFT_DISCOVERY_MAP_PATH}/${SHIFT_DISCOVERY_IN_HOME_PATH}`}
        analyticsTrigger="switchToInHomeMapView"
      />
    </Stack>
  );
}
